import React from "react";
import SimpleDialogDemo from "../../../Modals/SimpleDialog";
import { Paper, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";

// Ícono simple tipo "dorsal" (un rectángulo con dos ojales arriba, como un
// número de competencia) para diferenciar de un vistazo la alerta de dorsal
// fuera de rango de la alerta de edad/categoría (que sigue usando el ícono
// de advertencia de siempre).
function DorsalIcon({ size, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3.5"
        y="4"
        width="17"
        height="16"
        rx="1.5"
        fill="none"
        stroke={color}
        strokeWidth="1.6"
      />
      <circle cx="7" cy="7.3" r="1.1" fill={color} />
      <circle cx="17" cy="7.3" r="1.1" fill={color} />
      <text
        x="12"
        y="16"
        textAnchor="middle"
        fontSize="7.5"
        fontWeight="700"
        fill={color}
        fontFamily="Arial, sans-serif"
      >
        00
      </text>
    </svg>
  );
}

// Ícono de advertencia (más visible que un simple "*") que al hacer click
// muestra un mensaje explicativo — mismo patrón ya usado para DNF/DQ en
// resultados (DNFAndDQView.jsx + SimpleDialogDemo), reutilizado acá para
// avisos de edad fuera del rango de la categoría o dorsal fuera del rango
// de la modalidad. Solo informa, no bloquea nada — si no hay mensaje, no
// renderiza nada.
// `claro` se usa cuando el botón va sobre un fondo ya rojo (ej. la caja de
// Categoría en ModCatGenDetail.jsx) — ahí un ícono rojo quedaría invisible,
// así que se muestra en blanco con un círculo semitransparente en vez del
// circulito rosa claro de siempre.
// `tipo="dorsal"` cambia el ícono al de dorsal; cualquier otro valor (o
// ausente) deja el ícono de advertencia de siempre (usado para edad).
export default function ValidationAlertButton({ mensaje, claro, tipo }) {
  if (!mensaje) return null;
  const colorIcono = claro ? "#ffffff" : "#d32f2f";
  const colorCirculo = claro ? "rgba(255,255,255,0.3)" : "#ffebee";
  const esDorsal = tipo === "dorsal";
  return (
    <SimpleDialogDemo
      buttonText={
        <span
          title={mensaje}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: colorCirculo,
            borderRadius: "50%",
            width: 30,
            height: 30,
          }}
        >
          {esDorsal ? (
            <DorsalIcon size={22} color={colorIcono} />
          ) : (
            <WarningIcon style={{ color: colorIcono, fontSize: 24 }} />
          )}
        </span>
      }
      variant="text"
      paddingButton={2}
    >
      <Paper style={{ padding: 20 }}>
        {esDorsal ? (
          <div style={{ display: "flex", justifyContent: "center", margin: "0 0 10px" }}>
            <DorsalIcon size={40} color="#d32f2f" />
          </div>
        ) : (
          <WarningIcon style={{ color: "#d32f2f", fontSize: 40, display: "block", margin: "0 auto 10px" }} />
        )}
        <Typography variant="body1" align="center">
          {mensaje}
        </Typography>
      </Paper>
    </SimpleDialogDemo>
  );
}
